import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllAnnouncements = async ({
  companyCode,
  isTrue,
  locationCode,
  fromDate,
  toDate,
}) => {
  if (!locationCode && !companyCode) return [];
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllAnnouncement}?isTrue=${isTrue}&CompanyCode=${companyCode}&locationCode=${locationCode}&StartDate=${fromDate}&EndDate=${toDate}`
  );
  return data;
};

const getAnnouncementById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAnnouncementByID}?CompanyCode=${companyCode}&AnnouncementId=${code}`
  );
  return data;
};

const insertAnnouncement = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.InsertAnnouncement,
    input
  );
  return data;
};

const updateAnnouncement = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateAnnouncement,
    input
  );
  return data;
};

const deleteAnnouncement = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.DeleteAnnouncement}?CompanyCode=${companyCode}&AnnouncementId=${code}`
  );
  return data;
};

export const useGetAnnouncementsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllAnnouncement],
    queryFn: () => getAllAnnouncements(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetAnnouncementByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAnnouncementByID],
    queryFn: () => getAnnouncementById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertAnnouncementMutation = () => {
  return useMutation({
    mutationFn: insertAnnouncement,
  });
};

export const useUpdateAnnouncementMutation = () => {
  return useMutation({
    mutationFn: updateAnnouncement,
  });
};

export const useDeleteAnnouncementMutation = () => {
  return useMutation({
    mutationFn: deleteAnnouncement,
  });
};
